<template>
  <div>
    <ScrollupSection />
    <div class="main">
      <HeaderSection />
      <HeroSection />
      <CounterSection />
      <FeatureSection />
      <ServiceSection />
      <DiscoverSection />
      <WorkSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/ScrollupSection/scrollUp'
import HeaderSection from '../components/HeaderSection/headerOne'
import HeroSection from '../components/HeroSection/heroOne'
import CounterSection from '../components/CounterSection/counter'
import FeatureSection from '../components/FeatureSection/featureThree'
import ServiceSection from '../components/ServiceSection/serviceOne'
import DiscoverSection from '../components/DiscoverSection/discoverOne'
import WorkSection from '../components/WorkSection/work'
import FooterSection from '../components/FooterSection/footerOne'

export default {
  name: 'ThemeOne',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    CounterSection,
    FeatureSection,
    ServiceSection,
    DiscoverSection,
    WorkSection,
    FooterSection
  }
}
</script>

<style>

</style>